import {
  endOfYesterday,
  endOfDay,
  subDays,
  startOfYesterday,
  startOfWeek,
  startOfMonth,
  startOfYear,
  startOfDay,
  isSameDay,
} from 'date-fns';
import { RangeDatePreset } from '@paradigm/design-system/src/components/DatePicker';

export const getPresets = (
  apiLastUpdatedAt: number | null,
): RangeDatePreset<RelativeDate>[] => {
  const dateNow = new Date();
  // Api only calculates data up to the previous day it was last updated
  const availableDataLimitDate =
    apiLastUpdatedAt == null
      ? endOfYesterday()
      : endOfDay(subDays(apiLastUpdatedAt, 1));

  return [
    {
      label: 'Yesterday',
      value: [startOfYesterday(), availableDataLimitDate],
    },
    {
      label: '7 days',
      value: [
        // Subtract 1 day because we count 7 days including the first one (start of day)
        subDays(startOfDay(availableDataLimitDate), 7 - 1),
        availableDataLimitDate,
      ],
    },
    {
      label: '30 days',
      value: [
        subDays(startOfDay(availableDataLimitDate), 30 - 1),
        availableDataLimitDate,
      ],
    },
    {
      label: '90 days',
      value: [
        subDays(startOfDay(availableDataLimitDate), 90 - 1),
        availableDataLimitDate,
      ],
    },
    { label: 'WTD', value: [startOfWeek(dateNow), availableDataLimitDate] },
    { label: 'MTD', value: [startOfMonth(dateNow), availableDataLimitDate] },
    { label: 'YTD', value: [startOfYear(dateNow), availableDataLimitDate] },
    { label: 'All Time', value: [null, null] },
  ];
};

export type RelativeDate =
  | 'Yesterday'
  | '7 days'
  | '30 days'
  | '90 days'
  | 'WTD'
  | 'MTD'
  | 'YTD'
  | 'All Time';

export const findPresetByDate = (
  rangeDates: RangeDatePreset['value'],
  lastUpdatedAt: number | null,
) => {
  const presets = getPresets(lastUpdatedAt);
  const [startDate, endDate] = rangeDates;
  if (startDate == null || endDate == null) return null;

  return presets.find((preset) => {
    const [presetStart, presetEnd] = preset.value;
    if (presetStart == null || presetEnd == null) return false;

    return isSameDay(presetStart, startDate) && isSameDay(presetEnd, endDate);
  });
};
